export type UnauthorizedType = 'required' | 'optional';

export const UnauthorizedDispatcher = (type: UnauthorizedType = 'optional') => {
  const detail = {
    from: window.location.href,
    type
  };

  const evt = new CustomEvent('twygs:unauthorized', { detail });
  window.dispatchEvent(evt);
};
